export const statusStates = {
  IDLE: 'STATUS_IDLE',
  PENDING: 'STATUS_PENDING',
  SUCCESS: 'STATUS_SUCCESS',
  ERROR: 'STATUS_ERROR',
}
